import React from 'react';
import styled from 'styled-components/macro';

import { TermRelationshipType, EntityType } from '../../../../types.generated';
import { EmptyTab } from '../../shared/components/styled/EmptyTab';
import RelatedTerm from './RelatedTerm';

export enum RelatedTermTypes {
    isTypeOf = 'Has Type',
    typeOfRelations = 'Type Of',
    isRelatedTerms = 'Inherits',
    hasRelatedTerms = 'Contains',
    containedBy = 'Contained by',
    isAChildren = 'Inherited by',
    utilizedInTerms = 'Utilized In',
    utilizedByTerms = 'Utilized by',
    associatedWithTerms = 'Associated with',
    hasAssociationTerms = 'Has Association',
}

export type Props = {
    loading?: boolean;
    glossaryRelatedTermType: string;
    glossaryRelatedTermResult: Array<any>;
    trackTermLoading?: (urn: string, trackLoading: boolean) => void;
};

type GlossaryRelatedTerm = {
    urn: string;
    type: string;
    relationshipType: string;
};

const ListContainer = styled.div`
    width: 100%;
`;

export default function GlossaryRelatedTermsResult({
    loading,
    glossaryRelatedTermType,
    glossaryRelatedTermResult,
    trackTermLoading,
}: Props) {
    const glossaryRelatedTerms: Array<GlossaryRelatedTerm> = [];

    glossaryRelatedTermResult.forEach((item: any) => {
        glossaryRelatedTerms.push({
            urn: item?.entity?.urn,
            type: item?.entity?.type,
            relationshipType: item?.relationshipType,
        });
    });

    const relationshipType =
        glossaryRelatedTermType === RelatedTermTypes.hasRelatedTerms ||
        glossaryRelatedTermType === RelatedTermTypes.containedBy
            ? TermRelationshipType.HasA
            : TermRelationshipType.IsA;

    const getEntityType = (entityType: string) => {
        if (!entityType) {
            return EntityType.GlossaryTerm;
        }
        return entityType === EntityType.GlossaryTerm ? EntityType.GlossaryTerm : EntityType.GlossaryNode;
    };

    return (
        <ListContainer>
            {glossaryRelatedTerms.map((entity) => (
                <RelatedTerm
                    urn={entity?.urn}
                    isLoading={loading}
                    entityType={getEntityType(entity?.type)}
                    key={`${entity?.urn}-${entity?.relationshipType}`}
                    relationshipType={RelatedTermTypes[entity?.relationshipType] || relationshipType}
                    onLoadingChange={(isLoading) => trackTermLoading?.(entity?.urn, isLoading)}
                />
            ))}
            {glossaryRelatedTerms.length === 0 && <EmptyTab tab={glossaryRelatedTermType.toLocaleLowerCase()} />}
        </ListContainer>
    );
}
